import app from 'flarum/forum/app';
import Page from 'flarum/common/components/Page';
import m from 'mithril';
import { LEGAL } from '../legal';

/** /terms and /privacy: which one comes from the route. */
export default class LegalPage extends Page {
  key = 'terms';
  oninit(vnode) {
    super.oninit(vnode);
    this.key = m.route.get().split('?')[0].replace(/\/+$/, '').endsWith('/privacy') ? 'privacy' : 'terms';
    app.setTitle(LEGAL[this.key].title);
    app.setTitleCount(0);
  }
  view() {
    const doc = LEGAL[this.key];
    return m("div", {
      className: "BnLegal"
    }, m("h4", {
      className: "App-titleControl App-titleControl--text BnLegal-phoneTitle"
    }, doc.title), m("div", {
      className: "container"
    }, m("h1", {
      className: "BnLegal-title"
    }, doc.title), m("div", {
      className: "BnLegal-body"
    }, m.trust(doc.html))));
  }
}
flarum.reg.add('blizznux-home', 'forum/components/LegalPage', LegalPage);